import styled from 'styled-components';
import HelpQuestion from './HelpQuestion';
import { Separator } from '../shared/Separator';

const SectionTitleH2 = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${p => p.theme.c.text.primary};
  margin-bottom: 0;
  text-transform: uppercase;
`;

const SectionDiv = styled.div`
  margin-bottom: ${p => p.theme.unit(8)};

  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.unit(1)};
`;

const HelpSection = (props) => {
  const {
    helpSectionData = {},
    isMobile = false,
    onQuestionSelect,
    selectedQuestions,
  } = props;

  const {
    sectionTitle = '',
    helpQuestions = [],
    slug = '',
  } = helpSectionData;

  const allHelpQuestions = helpQuestions
    .map((question, index, self) => {
      const isLast = index === (self.length - 1);
      return (
        <HelpQuestion
          key={`help-question-${question.slug}`}
          helpQuestionData={question}
          isLast={isLast}
          sectionSlug={slug}
          isMobile={isMobile}
          onQuestionSelect={onQuestionSelect}
          selectedQuestions={selectedQuestions} />
      );
    });

  return (
    <SectionDiv id={slug}>
      <SectionTitleH2>
        { sectionTitle }
      </SectionTitleH2>

      <Separator />
      { allHelpQuestions }
    </SectionDiv>
  );
};

export default HelpSection;
